'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { ContextSuspensionBanners } from 'ui-suspension-banners-lib';
import NotificationList from 'ReduxMessenger/components/NotificationList';
import UIApplication from 'UIComponents/app/UIApplication';
import { FILE_MANAGER_ACCOUNT_VERIFICATION_SOURCE, FILE_MANAGER_WRITE_SCOPE } from 'FileManagerCore/Constants';
import { getHasFileManagerWriteScope, getHasFileHostingPaidDomainsScope, getHasVideoIntegrationScope, selectIsUngatedForBackendPoweredPagination } from 'FileManagerCore/selectors/Auth';
import { trackDashboardView } from '../utils/usageTracker';
import { appDidMount } from '../actions/ActionsTyped';
import ModalsContainer from './containers/ModalsContainer';
import { getSourceParam } from '../selectors/Query';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class Application extends Component {
  componentDidMount() {
    const {
      dispatch,
      hasFilesWrite,
      hasFileHostingPaidDomains,
      hasMarketingVideo,
      source,
      isUngatedForBackendPoweredPagination
    } = this.props;
    if (!isUngatedForBackendPoweredPagination) {
      dispatch(appDidMount(this.props.location));
    }
    trackDashboardView({
      hasFilesWrite,
      hasFileHostingPaidDomains,
      hasMarketingVideo,
      source
    });
  }
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/_jsxs(UIApplication, {
      name: "file-manager",
      children: [/*#__PURE__*/_jsx(NotificationList, {
        className: "notification-list"
      }), /*#__PURE__*/_jsx(ContextSuspensionBanners, {
        scope: FILE_MANAGER_WRITE_SCOPE,
        source: FILE_MANAGER_ACCOUNT_VERIFICATION_SOURCE
      }), /*#__PURE__*/_jsx(ModalsContainer, {}), children]
    });
  }
}
Application.propTypes = {
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  hasFilesWrite: PropTypes.bool.isRequired,
  hasFileHostingPaidDomains: PropTypes.bool.isRequired,
  hasMarketingVideo: PropTypes.bool.isRequired,
  source: PropTypes.string,
  isUngatedForBackendPoweredPagination: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired
};
const mapStateToProps = (state, props) => ({
  hasFilesWrite: getHasFileManagerWriteScope(state),
  hasFileHostingPaidDomains: getHasFileHostingPaidDomainsScope(state),
  hasMarketingVideo: getHasVideoIntegrationScope(state),
  source: getSourceParam(state, props),
  isUngatedForBackendPoweredPagination: selectIsUngatedForBackendPoweredPagination(state)
});
export default connect(mapStateToProps)(Application);